
export const Theme = {
    accent: "#C6AE92",
    primary: "#E0D2C7",
    secondary: "#C0B0A1",
    grey: "#E3E5E4",
    white: "#FFF",
    footer: "grey"
};